import styled from 'styled-components';
import { colors, r4, r8 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { FIELD_SELECTOR } from '@ardoq/forms';
import { BUTTON_SELECTOR } from '@ardoq/button';

const INDENTATION = 22;
export const ITEM_HEIGHT = 36;

const LINE_THICKNESS = 2;
const LINE_STYLE = `${LINE_THICKNESS}px dashed ${colors.blue400}`;

const EDITABLE_GAP = 20;
const READ_ONLY_GAP = 8;

const booleanSelector =
  (trueValue: number, falseValue: number) =>
  ({ $isReadOnly }: { $isReadOnly: boolean }): number =>
    $isReadOnly ? trueValue : falseValue;

export const ElWrapper = styled.div<{ $isReadOnly: boolean }>`
  border-radius: ${r4};
  position: relative;
  margin-top: ${booleanSelector(READ_ONLY_GAP, EDITABLE_GAP)}px;
  &::after {
    content: '';
    position: absolute;
    top: -${booleanSelector(READ_ONLY_GAP, EDITABLE_GAP)}px;
    left: -${INDENTATION}px;
    border-bottom: ${LINE_STYLE};
    width: ${INDENTATION}px;
    height: ${booleanSelector(
      ITEM_HEIGHT / 2 + READ_ONLY_GAP,
      ITEM_HEIGHT / 2 + EDITABLE_GAP
    )}px;
  }
  &:last-child::after {
    border-left: ${LINE_STYLE};
    border-radius: 0 0 0 ${r8};
  }
  &:not(:last-child)::before {
    content: '';
    position: absolute;
    top: -${booleanSelector(READ_ONLY_GAP, EDITABLE_GAP)}px;
    left: -${INDENTATION}px;
    border-left: ${LINE_STYLE};
    width: ${INDENTATION}px;
    height: calc(
      100% +
        ${booleanSelector(
          READ_ONLY_GAP - LINE_THICKNESS,
          EDITABLE_GAP - LINE_THICKNESS
        )}px
    );
  }
`;

export const TreeWrapper = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'xlarge',
})`
  position: relative;

  & > ${ElWrapper} {
    margin-top: 0;
    &::after {
      display: none;
    }
  }
`;

export const TreeWrapperMainWrapper = styled(FlexBox).attrs({
  flexDirection: 'column',
  gap: 'xlarge',
})`
  & > ${FIELD_SELECTOR} {
    width: 200px;
  }
  & > ${BUTTON_SELECTOR} {
    align-self: flex-start;
  }
`;

export const ChildrenWrapper = styled.div<{ $isReadOnly: boolean }>`
  margin-left: ${INDENTATION}px;
  padding-left: ${INDENTATION}px;
`;
